import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BRAND_LOGO_PATH, getSiteOrigin } from '../../lib/siteConfig';

/**
 * Organization + LocalBusiness JSON-LD for homepage.
 * Supports local (GEO) SEO for Philippines real estate.
 */
export function OrganizationSchema() {
  const origin = getSiteOrigin();
  const logoUrl = `${origin}${BRAND_LOGO_PATH}`;

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${origin}/#organization`,
        name: 'RentaBahay Real Estate',
        url: origin,
        logo: {
          '@type': 'ImageObject',
          url: logoUrl,
        },
        description: 'Premium Philippine real estate rentals. Find apartments, houses, and condos in Manila, Cebu, Davao, Makati, BGC, and Quezon City.',
        sameAs: [],
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          availableLanguage: ['English', 'Filipino'],
          areaServed: 'PH',
        },
      },
      {
        '@type': 'RealEstateAgent',
        '@id': `${origin}/#agent`,
        name: 'RentaBahay Real Estate',
        url: origin,
        areaServed: {
          '@type': 'Country',
          name: 'Philippines',
        },
        parentOrganization: { '@id': `${origin}/#organization` },
      },
      {
        '@type': 'WebSite',
        '@id': `${origin}/#website`,
        url: origin,
        name: 'RentaBahay - Philippine Real Estate Rentals',
        description: 'Find your dream home in the Philippines. Property rentals in Manila, Cebu, Davao, Makati, BGC, Quezon City.',
        publisher: { '@id': `${origin}/#organization` },
        inLanguage: 'en-US',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${origin}/search?q={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
